import React, { useRef, useEffect, useState } from 'react';
import './Audience.css';

const audienceData = [
  { title: 'Digital Marketing Agencies', description: 'Manage campaigns and client relations efficiently with unified tools.' },
  { title: 'Freelance Consultants', description: 'Simplify client onboarding, invoicing, and project management.' },
  { title: 'IT services and managed service providers', description: 'Deliver reliable outsourced support and track team productivity.' },
  { title: 'SaaS Startups', description: 'Scale operations with integrated billing, analytics, and communications.' },
  { title: 'Web Development Firms', description: 'Organize client projects, invoice easily, and collaborate seamlessly.' },
  { title: 'SEO Agencies', description: 'Manage campaigns, reports, and client communications in one platform.' },
  { title: 'Content Creation Studios', description: 'Coordinate multimedia projects, invoicing, and team tasks efficiently.' },
  { title: 'Online Education', description: 'Manage course enrollments, scheduling, and payments simply.' },
  { title: 'HR Recruitment Agencies', description: 'Track candidates, client contracts, and streamline payroll processing.' },
  { title: 'Law Firms', description: 'Efficiently manage case files, invoices, and client relationships.' },
  { title: 'Graphic Design Studios', description: 'Track creative projects, billing milestones, and client feedback.' },
  { title: 'Event Planning Services', description: 'Organize events, budgets, and vendor payments with ease.' },
  { title: 'Virtual Assistant Companies', description: 'Manage client tasks, billing, and team time tracking effortlessly.' },
  { title: 'Influencer Management Agencies', description: 'Streamline influencer campaigns, contracts, and payments.' },
  { title: 'Financial Planning/Advisory Firms', description: 'Handle client portfolios, billing, and reporting in one place.' },
  { title: 'Animation & Video Production Houses', description: 'Manage productions, deadlines, client invoices, and analytics.' },
  { title: 'Health Coaches/Online Fitness Instructors', description: 'Schedule sessions, invoice clients, and track progress digitally.' },
  { title: 'UX/UI Consulting Firms', description: 'Deliver client projects, billing, and collaborative feedback easily.' },
  { title: 'Mobile App Developers', description: 'Track development milestones, invoicing, and team productivity.' },
  { title: 'Copywriting & Content Agencies', description: 'Manage writing projects, deadlines, and billing seamlessly.' },
  { title: 'Translation & Localization Agencies', description: 'Track assignments, client contracts, and payments centrally.' },
  { title: 'Social Media Management Companies', description: 'Coordinate campaigns, client communications, and invoicing smoothly.' },
  { title: 'PR & Communications Consultancies', description: 'Manage media outreach, client contracts, and payments efficiently.' },
  { title: 'Software Product Development Studios', description: 'Track feature development, client billing, and team tasks.' },
  { title: 'Custom Analytics & BI Firms', description: 'Deliver client reports, invoicing, and project progress simply.' },
  { title: 'Podcast & Webinar Production Teams', description: 'Organize episodes, guest schedules, and client billing.' },
  { title: 'E-learning Content Studios', description: 'Manage course creation, client contracts, and payments digitally.' },
  { title: 'Small Architecture & Design Practices', description: 'Track design projects, invoices, and client communication effortlessly.' },
  { title: 'CA & Accounting firms', description: 'Automate client invoicing, payroll, and document management.' },
  { title: 'Fundraising Advisory for Startups/NGOs', description: 'Manage fundraising projects, client billing, and reports.' },
  { title: 'Branding Studios', description: 'Streamline creative projects, client contracts, and invoicing.' },
  { title: 'Market Research Agencies', description: 'Manage surveys, reporting schedules, and client billing easily.' },
  { title: 'Cybersecurity Consultancies', description: 'Track audits, client invoices, and team productivity seamlessly.' },
  { title: 'Remote Project Management Firms', description: 'Organize distributed teams, project billing, and client updates.' },
  { title: '3D Modeling & CAD Design Consultancies', description: 'Manage client projects, invoices, and revisions effectively.' },
  { title: 'Digital Publishing & Magazine Teams', description: 'Coordinate publications, billing, and contributor management.' },
  { title: 'Video Editors for YouTubers & Creators', description: 'Manage editing projects, client invoicing, and deadlines digitally.' },
  { title: 'Online Therapy & Mental Health Startups', description: 'Schedule sessions, bill clients, and manage confidential notes safely.' },
  { title: 'Boutique Legal Consultants', description: 'Track client cases, contracts, and billing easily and securely.' },
  { title: 'Customer Support Outsourcing Providers', description: 'Manage tickets, client accounts, and payroll efficiently.' },
  { title: 'Website Maintenance & Support Firms', description: 'Track maintenance schedules, billing, and client communication.' },
  { title: 'Specialized Consulting (Sustainability, DEI)', description: 'Manage projects, invoicing, and client relations effectively.' },
  { title: 'Not-for-profit Service Organizations', description: 'Handle volunteer coordination, fundraising, and billing with ease.' },
  { title: 'B2B Partnership/Brokerage Agencies', description: 'Track deals, client invoicing, and communications smoothly.' },
  { title: 'AR/VR Solution Providers', description: 'Manage immersive projects, client billing, and team collaboration.' },
  { title: 'Influencer, Creator & Talent Agencies', description: 'Simplify contract management, payments, and campaign tracking.' },
  { title: 'Voiceover & Audiobooks Studios', description: 'Manage talent, projects, and invoicing in one platform.' },
  { title: 'Interior Design Consultancies', description: 'Track client projects, billing milestones, and vendor coordination.' },
  { title: 'Remote Sales & Lead Generation Agencies', description: 'Organize sales pipelines, invoices, and remote team workflows.' },
  { title: 'Podcast Editing & Management Companies', description: 'Manage client episodes, billing, and production timelines neatly.' }
];

const duplicatedData = [...audienceData, ...audienceData];

function Audience() {
  const scrollRef = useRef();
  const [isPaused, setIsPaused] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  useEffect(() => {
    if (isMobile) return;

    const scrollContainer = scrollRef.current;
    let scrollAmount = 0.5;
    let reqId;

    function animateScroll() {
      if (scrollContainer && !isPaused) {
        scrollContainer.scrollLeft += scrollAmount;
        if (scrollContainer.scrollLeft >= scrollContainer.scrollWidth / 2) {
          scrollContainer.scrollLeft = 0;
        }
      }
      reqId = requestAnimationFrame(animateScroll);
    }

    reqId = requestAnimationFrame(animateScroll);
    return () => cancelAnimationFrame(reqId);
  }, [isPaused, isMobile]);

  return (
    <section 
      id="audience" 
      className="audience-section"
      onMouseEnter={() => !isMobile && setIsPaused(true)}
      onMouseLeave={() => !isMobile && setIsPaused(false)}
    >
      <h2 className="audience-title">Built for Modern Entrepreneurs Like You</h2>
      
      <div className="audience-scroll" ref={scrollRef}>
        <div className="audience-grid">
          {duplicatedData.map((item, idx) => (
            <div key={item.title + idx} className="audience-card">
              <h3>{item.title}</h3>
              <p>{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Audience;